import { styled } from '@mui/material/styles';
import { Menu } from '@mui/material';

export const BARHEIGHT = 14;
export const BARWIDTH = 40;
export const COLORS = {
  reallightGray: '#f1f1f1ff',
  lightGray: '#DFDFDF',
  darkGrey: '#A0A0A1',
  green: '#61EB4F',
  red: '#FF0000',
};

// Generic icon-wrap CSS for any score icon. Used as a className via the .scoreIcon / .scoreIconDisabled classes.
export const ScoreIconWrap = styled('span', {
  shouldForwardProp: (prop) => prop !== 'isDisabled',
})(({ theme, isDisabled }) => ({
  display: 'inline-flex',
  cursor: isDisabled ? 'default' : 'pointer',
  pointerEvents: isDisabled ? 'none' : 'all',
  paddingRight: theme.spacing(0.5),
}));

export const CompareWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: BARWIDTH + 35,
  marginRight: theme.spacing(1),
  padding: theme.spacing(1),

  '&.compareHover': {
    '&:hover': {
      backgroundColor: theme.palette.action.disabledBackground,
      cursor: 'pointer',
      borderRadius: 5,
    },
  },

  '& .barContainer': {
    display: 'flex',
    flexDirection: 'row',
    width: BARWIDTH,
    height: BARHEIGHT,
    border: `1px solid ${theme.palette.divider}`,
    position: 'relative',
  },

  '& .bar': {
    backgroundColor: theme.palette.divider,
    position: 'relative',
  },

  '& .text': {
    fontSize: 12,
    marginLeft: 5,
  },
}));

export const CompareModal = styled(Menu)(({ theme }) => ({
  '& .container': {
    padding: theme.spacing(1),
    maxWidth: 450,
    minWidth: 320,
    minHeight: 400,
  },

  '& .header': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
